/**
 * æ¥è¯¢æ¡ä»¶è§å¾
 *
 */
export interface SelectConditionViewModel {
  /**
   * æ¯å¦éä¸­
   */
  checked?: boolean;
  /**
   * æ¨¡æ¿
   *
   */
  templateType?: string;

  /**
   * å³èå±æ§
   */
  entityAttribute?: string;
  /**
   * åºåå·
   *
   * @memberof QueryCondition
   */
  serialNo?: number;
  /**
   * æ¥è¯¢è§å
   *
   * @memberof QueryCondition
   */
  rule?: string;
}

/**
 * @description æ¥è¯¢æ¡ä»¶
 *
 */
export interface SelectCondition {
  /**
   * ç±»å
   *
   * @memberof QueryCondition
   */
  type: string;
  /**
   * å®ä½code
   * @memberof QueryCondition
   */
  dataEntityCode: string;
  /**
   * å®ä½å±æ§code
   *
   * @memberof QueryCondition
   */
  dataAttrCode: string;
  /**
   * å®ä½å±æ§åå§å¼
   *
   * @memberof SelectCondition
   */
  dataAttrOrigin?: any;
  /**
   * åºåå·
   *
   * @memberof QueryCondition
   */
  serialNo: number;
  /**
   * æ¥è¯¢è§å
   *
   * @memberof QueryCondition
   */
  rule: string;

  /**
   * åç§°
   *
   * @memberof QueryCondition
   */
  caption: string;

  /**
   * @description æ§ä»¶model
   *
   * @memberof SelectCondition
   */
  model?: any;
}

/**
 * @description å±ç¤ºæ¡ä»¶
 *
 */
export interface ShowCondition {
  /**
   * ç±»å
   *
   * @memberof QueryCondition
   */
  type: string;
  /**
   * å®ä½code
   * @memberof QueryCondition
   */
  dataEntityCode: string;
  /**
   * å®ä½å±æ§code
   *
   * @memberof QueryCondition
   */
  dataAttrCode: string;
  /**
   * å¤ä¸ªå®ä½å±æ§
   *
   * @memberOf ShowCondition
   */
  multiDataAttrCode: any[];
  /**
   * åºåå·
   *
   * @memberof QueryCondition
   */
  serialNo: number;
  /**
   * åç§°
   *
   * @memberof QueryCondition
   */
  caption: string;
  /**
   * @description æ§ä»¶model
   *
   * @memberof SelectCondition
   */
  model?: any;
}

/**
 * å±ç¤ºæ¡ä»¶
 *
 * @export
 */
export interface Condition {
  selectCondition: Array<SelectCondition>;
  showCondition: Array<ShowCondition>;
}

/**
 * è·åæ¥è¯¢æ¡ä»¶æ è¯
 *
 * @export
 */
export function getSelectConditionIdentity(condition: { dataEntityCode?: string; dataAttrCode?: string }): string {
  return `${condition.dataEntityCode}.${condition.dataAttrCode}`;
}
